/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import {
  type ContextValue,
  UNSTABLE_Toast as ToastCore,
  type ToastProps as ToastCoreProps,
  useContextProps,
} from 'react-aria-components';

interface ToastProps<T> extends Omit<ToastCoreProps<T>, 'style' | 'className'> {
  /** The slot of the toast. */
  slot?: string;
  style?: stylex.StyleXStyles;
}

const ToastContext = createContext<ContextValue<ToastProps<object>, HTMLDivElement>>({});

const Toast = forwardRef((props: ToastProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ToastContext);

  const { style, children, ...coreProps } = props;

  return (
    <ToastCore ref={ref} {...stylex.props(styles.base(coreProps.toast.key), style)} {...coreProps}>
      {children}
    </ToastCore>
  );
}) as <T>(p: ToastProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const fadeOut = stylex.keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

const fadeIn = stylex.keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

const viewTransition = stylex.viewTransitionClass({
  new: {
    animationDuration: '400ms',
    animationFillMode: 'forwards',
    animationName: fadeIn,
  },
  old: {
    animationDuration: '400ms',
    animationFillMode: 'forwards',
    animationName: fadeOut,
  },
});

const styles = stylex.create({
  base: (viewTransitionName: string) => ({
    // eslint-disable-next-line @stylexjs/valid-styles
    viewTransitionClass: viewTransition,
    pointerEvents: 'auto',
    viewTransitionName,
  }),
});

const TOAST_SLOTS = {
  CLOSE: 'close',
};

const TOAST_TIMEOUT = 3000;

export { TOAST_SLOTS, TOAST_TIMEOUT, Toast, ToastContext, type ToastProps };
